export default {
  RECOVERY_CODE_INVALID_OR_EXPIRED: 'RECOVERY_CODE_INVALID_OR_EXPIRED',
  RECOVERY_CODE_ERROR: 'RECOVERY_CODE_ERROR',
  SAVE_PASSWORD_ERROR: 'SAVE_PASSWORD_ERROR',
  RECOVER_BY_EMAIL_ERROR: 'RECOVER_BY_EMAIL_ERROR',
  RECOVER_BY_EMAIL_INVALID: 'RECOVER_BY_EMAIL_INVALID',
  RECOVER_BY_PHONE_ERROR: 'RECOVER_BY_PHONE_ERROR',
  RECOVER_BY_PHONE_INVALID: 'RECOVER_BY_PHONE_INVALID'
};